<template>
  <section
      class="ads-container d-flex"
      ref="adContainer"
      :class="{ 'hide-ads-container': !adVisible }"
      :style="{
        '--ad-max-width': adMaxWidth,
        '--ad-max-height': adMaxHeight
      }"
  >
    <ins
        class="adsbygoogle"
        style="display:block; width:100%; height:100%;"
        data-ad-client="ca-pub-9277187477340577"
        :data-ad-slot="adSlotId"
        :data-ad-format="adFormat"
        :data-adbreak-test="isStaging ? 'on' : null"
        :data-ad-test="isStaging ? 'on' : null"
        data-full-width-responsive="true"
    ></ins>
  </section>
</template>

<script>
export default {
  name: 'AdsContainer',
  props: {
    refreshKey:   { type: Number,       default: 0    },
    maxWidth:     { type: [String,Number], default: null },
    maxHeight:    { type: [String,Number], default: null },
    adFormat:    { type: [String], default: "auto" },
    adType:    {
      type: [Number],
      default: 0,
      validator(val) {
        return [0, 1].includes(val);
      }
    } // 0 - responsive, 1 - multiplex
  },
  data() {
    return {
      isStaging:    process.env.NODE_ENV !== 'production',
      adVisible:    true,
      slots: ["9155878243", "5438781434"],
      _lastRefreshTs: 0,
      _minInterval: 60 * 1000,
      _isUnmounted: false
    }
  },
  computed: {
    adMaxWidth() {
      if (this.maxWidth == null) return '100%'
      return typeof this.maxWidth === 'number'
          ? `${this.maxWidth}px`
          : this.maxWidth
    },
    adMaxHeight() {
      if (this.maxHeight == null) return '200px'
      return typeof this.maxHeight === 'number'
          ? `${this.maxHeight}px`
          : this.maxHeight
    },
    adSlotId() {
      return this.slots[this.adType] || this.slots[0];
    }
  },
  watch: {
    refreshKey() { this._rerenderAd() },
    adVisible(newVal, oldVal) {
      if (newVal && !oldVal) this.$emit('show');
      if (!newVal && oldVal) this.$emit('hide');
    }
  },
  mounted() {
    this._isUnmounted = false
    this._setupObserver()
    this._initialPush()
  },
  unmounted() {
    this._isUnmounted = true
  },
  methods: {
    _setupObserver() {
      const getIns = () =>
          this.$refs.adContainer &&
          this.$refs.adContainer.querySelector('ins.adsbygoogle');
      const ins = getIns();
      if (!ins) return;

      const obs = new MutationObserver(ms => {
        ms.forEach(m => {
          if (m.attributeName === 'data-ad-status') {
            this.adVisible = ins.getAttribute('data-ad-status') === 'filled';
          }
        });
      });
      obs.observe(ins, { attributes: true, attributeFilter: ['data-ad-status'] });
      setTimeout(() => {
        if (this._isUnmounted) return;
        const section = this.$refs.adContainer;
        const ins = section && section.querySelector('ins.adsbygoogle');
        const hasIframe = ins && ins.querySelector('iframe');
        if (!ins || !hasIframe || ins.offsetHeight === 0 || section.offsetHeight === 0) {
          this.adVisible = false;
        }
      }, 10000);

    },
    _initialPush() {
      this._lastRefreshTs = Date.now()
      const ins = this.$refs.adContainer.querySelector('ins.adsbygoogle')
      this._safeAdPush(ins)
    },
    _rerenderAd() {
      const now = Date.now()
      if (now - this._lastRefreshTs < this._minInterval) {
        console.warn(
            `AdsContainer: skipping refresh (${Math.round((now-this._lastRefreshTs)/1000)}s since last)`
        )
        return
      }
      const ins = this.$refs.adContainer.querySelector('ins.adsbygoogle')
      if (!ins) return
      ins.innerHTML = ''
      this._lastRefreshTs = now
      this._safeAdPush(ins)
    },
    _safeAdPush(ins, attempts = 0) {
      // Stop if gone
      if (!ins || this._isUnmounted || !this.$el || !document.body.contains(this.$el)) return
      // After 10 attempts (3s), hide
      if (attempts > 10) {
        this.adVisible = false
        return
      }
      if (
          ins.offsetParent !== null &&
          ins.offsetWidth > 0 &&
          ins.offsetHeight > 0 &&
          window.adsbygoogle
      ) {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      } else {
        setTimeout(() => this._safeAdPush(ins, attempts + 1), 600)
      }
    }
  }
}
</script>

<style scoped>
.ads-container {
  padding: 5px;
  width: 100%;

  /* clamp the wrapper */
  max-width: var(--ad-max-width);
  max-height: var(--ad-max-height);
  overflow: hidden;
}

.hide-ads-container {
  visibility: hidden;
  position: absolute;
}

/* clamp the injected <ins> and its inner <iframe> */
.ads-container ins,
.ads-container ins > ins,
.ads-container iframe {
  max-width: var(--ad-max-width)    !important;
  max-height: var(--ad-max-height)  !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden                  !important;
}
</style>
